var _AppStateManager;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import formatLegacyFlippers from '../../utils/formatLegacyFlippers';
import getOptionalValue from '../../utils/getOptionalValue';
import isSSR from '../../utils/isSSR';
import { AppState, AppStateEvent, NavigationState } from '../constants';
import StateManager from './StateManager';
import { detectDevice } from '../../utils/akamaiCookies/device-api';
export default class AppStateManager extends StateManager {
  constructor({
    instanceId = AppStateManager.InstanceId,
    pathToData = '__APP_STATE__',
    cookies: _cookies,
    enabledFlippers: _enabledFlippers,
    isBot: _isBot
  } = {}) {
    super({
      instanceId,
      pathToData
    });
    _defineProperty(this, "pathToData", '__APP_STATE__');
    _defineProperty(this, "state", {});
    _defineProperty(this, "setters", {});
    _defineProperty(this, "updateDerivedValues", (triggerChangeEvent = false) => {
      const enabledFlippers = this.state?.[AppState.EnabledFlippers]?.enabledFlippers;
      this.state[AppState.Flippers] = enabledFlippers ? formatLegacyFlippers(enabledFlippers) : {};
      if (triggerChangeEvent) {
        this.emit(AppStateEvent.Change(AppState.Flippers));
      }
    });
    _defineProperty(this, "getInitialAppState", ({
      enabledFlippers,
      isBot,
      cookies
    } = {}) => {
      const deviceData = detectDevice(cookies);
      return {
        pageNavigation: {
          timestamp: `${Date.now()}`,
          pageinstance: (Math.random() * 10000000000000000).toFixed(0)
        },
        enabledFlippers: {
          fromSSR: !!enabledFlippers,
          enabledFlippers
        },
        isBot: {
          isBot
        },
        device: {
          deviceData,
          isDesktop: deviceData && deviceData.isdesktop
        },
        navigationState: NavigationState.Complete
      };
    });
    _defineProperty(this, "getSerializableData", () => {
      const state = {
        ...this.state
      };
      delete state.triggeredPageReady;
      delete state.flippers;
      return state;
    });
    _defineProperty(this, "getSerializedScript", () => `
    window.getApplicationState = function(name) { return window.${this.pathToData}[name]; }
    window.getEnabledFlippers = function() { return window.getApplicationState('enabledFlippers'); };
    window.getPageNavigation = function() { return window.getApplicationState('pageNavigation'); };
    window.getTriggeredPageReady = function() { return window.getApplicationState('triggeredPageReady'); };
    window.getIsBot = function() { return window.getApplicationState('isBot'); };
  `);
    _defineProperty(this, "getSetter", name => {
      if (!this.setters[name]) {
        this.setters[name] = value => {
          this.set(name, value);
        };
      }
      return this.setters[name];
    });
    _defineProperty(this, "set", (name, value) => {
      if (this.state[name] !== value) {
        this.state[name] = value;
        if (name === AppState.EnabledFlippers) {
          this.updateDerivedValues(true);
        }
        this.emit(AppStateEvent.Change(name));
      }
    });
    _defineProperty(this, "get", name => {
      return this.state[name];
    });
    _defineProperty(this, "waitForValue", valueName => new Promise(resolve => {
      if (this.get(valueName)) {
        resolve();
      }
      const onValueChange = () => {
        if (this.get(valueName)) {
          this.off(AppStateEvent.Change(valueName), onValueChange);
          resolve();
        }
      };
      this.on(AppStateEvent.Change(valueName), onValueChange);
    }));
    if (isSSR()) {
      this.state = this.getInitialAppState({
        enabledFlippers: _enabledFlippers,
        isBot: _isBot,
        cookies: _cookies
      });
    } else {
      this.state = getOptionalValue(window, this.pathToData) || this.getInitialAppState({
        enabledFlippers: _enabledFlippers,
        isBot: _isBot,
        cookies: _cookies
      });
      window.getApplicationState = name => this.state[name];
      window.getEnabledFlippers = () => this.state.enabledFlippers;
      window.getPageNavigation = () => this.state.pageNavigation;
      window.getTriggeredPageReady = () => this.state.triggeredPageReady;
      window.getIsBot = () => this.state.isBot;
    }
    this.updateDerivedValues();
  }
}
_AppStateManager = AppStateManager;
_defineProperty(AppStateManager, "InstanceId", 'AppStateManager');
_defineProperty(AppStateManager, "getInstance", context => StateManager.getInstance(_AppStateManager, context));